import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { elementActions } from '@app/store/element/actions/element.actions';
import { elementsActions } from '../actions/elements.actions';
import { selectValue } from '../selectors/elements.selector';

@Injectable()
export class ElementsElementBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(elementActions.deleteElementSuccess),
            concatLatestFrom(() => this.store.select(selectValue)),
            map(([, value]) => elementsActions.getElements({ value })),
        );
    });
}
